import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './form-item-business-public-sector-cmb.component.scss';
var FormItemBusinessPublicSectorCmb = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessPublicSectorCmb, _super);
    function FormItemBusinessPublicSectorCmb(element) {
        return _super.call(this, element) || this;
    }
    FormItemBusinessPublicSectorCmb.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.areaOfInterest = this.element.querySelector(".js-select-areaofint");
        this.otherArea = this.element.querySelector("input[name=other-interest]");
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
        this.buttonSubmit = this.element.querySelector(".js_submit-button");
        this.doneSubmit = this.element.querySelector(".js_done-button");
        this.closeButton = this.element.querySelector('.js-apply-now-modal-close');
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.dataSharingTeleSaleHideBtn = this.element.querySelector('.data-sharing-telesale-hide-btn');
        this.dataSharingTeleSaleShowBtn = this.element.querySelector('.data-sharing-telesale-show-btn');
        this.dataSharingTeleSaleTextArea = this.element.querySelector('.data-sharing-telesale');
        this.dataSharingSmsShowBtn = this.element.querySelector('.data-sharing-email-show-btn');
        this.dataSharingSmsHideBtn = this.element.querySelector('.data-sharing-email-hide-btn');
        this.dataSharingSmsTextArea = this.element.querySelector('.data-sharing-email');
        this.dataSharingEmailHideBtn = this.element.querySelector('.data-sharing-sms-hide-btn');
        this.dataSharingEmailShowBtn = this.element.querySelector('.data-sharing-sms-show-btn');
        this.dataSharingEmailTextArea = this.element.querySelector('.data-sharing-sms');
    };
    FormItemBusinessPublicSectorCmb.prototype.bindEvents = function () {
        var _this = this;
        //Submit Button Click
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _button = pEvent.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
            });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener('click', function (event) { return _this.closeForm("done"); });
        }
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.closeForm("close"); });
        }
        if (this.areaOfInterest) {
            this.areaOfInterest.addEventListener("change", function (event) {
                _this.toggleModifiers(event, ".js-other-area-interest");
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
        this.dataSharingTeleSaleShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.removeAttribute('hidden');
            _this.dataSharingTeleSaleShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleHideBtn.removeAttribute('hidden');
        });
        this.dataSharingTeleSaleHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleShowBtn.removeAttribute('hidden');
        });
        this.dataSharingSmsShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.removeAttribute('hidden');
            _this.dataSharingSmsShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingSmsHideBtn.removeAttribute('hidden');
        });
        this.dataSharingSmsHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.setAttribute('hidden', 'true');
            _this.dataSharingSmsHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingSmsShowBtn.removeAttribute('hidden');
        });
        this.dataSharingEmailShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.removeAttribute('hidden');
            _this.dataSharingEmailShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingEmailHideBtn.removeAttribute('hidden');
        });
        this.dataSharingEmailHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.setAttribute('hidden', 'true');
            _this.dataSharingEmailHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingEmailShowBtn.removeAttribute('hidden');
        });
    };
    FormItemBusinessPublicSectorCmb.prototype.toggleModifiers = function (event, selector) {
        var _this = this;
        if (event === void 0) { event = null; }
        var targetModifier = this.element.querySelector(selector);
        var formFields = targetModifier.querySelectorAll("input");
        var element = event.target;
        if (targetModifier) {
            if (element.value.toLowerCase() === "other") {
                targetModifier.classList.remove("form-item-business-public-sector-cmb__hidden");
                targetModifier.classList.add("form-item-business-public-sector-cmb__active");
                formFields.forEach(function (field) {
                    field.classList.add("form__input--required");
                    _this.removeErrorMessage(field);
                });
            }
            else {
                formFields.forEach(function (field) {
                    field.classList.remove("form__input--required");
                    field.value = '';
                    _this.removeErrorMessage(field);
                });
                targetModifier.classList.remove("form-item-business-public-sector-cmb__active");
                targetModifier.classList.add("form-item-business-public-sector-cmb__hidden");
            }
        }
    };
    FormItemBusinessPublicSectorCmb.prototype.removeErrorMessage = function (field) {
        this.errors = [];
        this.errors2 = [];
        var formGroup = field.closest('.form__group');
        if (formGroup) {
            field.closest('.form__group').classList.remove('form__group--error');
            var errorMessage = field.closest('.form__group').querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        }
    };
    FormItemBusinessPublicSectorCmb.prototype.removeErrorMessageFields = function (fields) {
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            var formGroup = field.closest('.form__group');
            if (field.type != 'hidden') {
                if (formGroup) {
                    field.closest('.form__group').classList.remove('form__group--error');
                    var errorMessage = field.querySelector(".form__group--error_message");
                    if (errorMessage) {
                        errorMessage.remove();
                    }
                }
            }
        }
    };
    FormItemBusinessPublicSectorCmb.prototype.closeForm = function (type) {
        if (type === "close") {
            this.analyticsService.dtmFormAbandon();
            window.location.href = this.closeButton.getAttribute('data-url');
        }
        else {
            window.location.href = this.doneSubmit.getAttribute('data-url');
        }
        this.form.reset();
    };
    FormItemBusinessPublicSectorCmb.prototype.submitForm = function (form) {
        var _this = this;
        var email = form.querySelector("input[name=email]");
        var recipient = form.querySelector("input[name=recipient]");
        var subject = form.querySelector("input[name=subject]");
        var firstname = form.querySelector("input[name=first-name]");
        var lastname = form.querySelector("input[name=last-name]");
        var province = form.querySelector("select[name=select-province]");
        var areaOfInterest = form.querySelector("select[name=select-areaofint]");
        var phoneNumber = form.querySelector("input[name=phone-number]");
        var emailAddress = form.querySelector("input[name=email-address]");
        var popiaConsent = form.querySelector("input[name=popia-consent]");
        var otherareaofinterest = form.querySelector("input[name=other-interest]");
        var _postData = {
            'subject': (subject ? subject.value : ""),
            'email': (email ? email.value : ""),
            'recipient': (recipient ? recipient.value : ""),
            'formLocation': this.formLocationService.getLocation(),
            'firstname': (firstname ? firstname.value : ""),
            'surname': (lastname ? lastname.value : ""),
            'contactNo': (phoneNumber ? phoneNumber.value : ""),
            'emailAddress': (emailAddress ? emailAddress.value : ''),
            'province': (province ? province.value : ""),
            'areaOfInterest': areaOfInterest ? areaOfInterest.value : "",
            'otherAreaOfInterest': otherareaofinterest ? otherareaofinterest.value : "",
            'popiConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
            'source': this.formsService.isMobile(),
            'dataSharingGroup': this.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharing3rdParty': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingBoarders': this.getDataConsentValue(form, 'data-sharing-boarders'),
            'dataSharingTelesale': this.getDataConsentValue(form, 'data-sharing-telesale'),
            'dataSharingEmail': this.getDataConsentValue(form, 'data-sharing-email'),
            'dataSharingSms': this.getDataConsentValue(form, 'data-sharing-sms')
        };
        this.showDisplayView("loader");
        var url = this.baseUrl + '/bcleadUtils/public-sector-lead';
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config).then(function (pResponse) {
            if (pResponse.data.valid === "invalid") {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.analyticsService.dtmFormComplete("complete", pResponse.data.applicationId);
                _this.showDisplayView("success");
            }
        }).catch(function (pError) {
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemBusinessPublicSectorCmb.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return '';
        }
    };
    FormItemBusinessPublicSectorCmb.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
        }
    };
    return FormItemBusinessPublicSectorCmb;
}(Base));
export { FormItemBusinessPublicSectorCmb };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-business-public-sector-cmb/form-item-business-public-sector-cmb.component.ts
// module id = 1105
// module chunks = 0